import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectInput } from '../../../models/inputs/select-input';
import { AddClearOptionPipe } from '../../../pipes';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-multi-select-input',
    standalone: true,
    imports: [MultiSelectModule, FormsModule, ReactiveFormsModule, AsyncPipe, AddClearOptionPipe, TranslateModule],
    template: `
        <p-multiSelect
            inputId="{{ 'input-' + name }}"
            [class]="control.inputClass.join(' ')"
            [placeholder]="control.placeholder! | translate"
            [options]="(control.options | async) ?? [] | addClearOption : control.clearable!"
            [formControl]="control"
            optionLabel="label"
            optionValue="value"
        ></p-multiSelect>
    `
})
export class MultiSelectInputComponent<T, E> extends BaseInputComponent<T> {
    @Input() name!: string;
    @Input() override control!: SelectInput<T, E>;
}
